import React, { Component } from 'react';
import { getSession, isExpressCheckout, isMobile, validateUrl } from '../../Helpers';

class ChatAndC2C extends Component {
  chatICON = (
    <div id="LPMcontainer-1676894258022-7" className="LPMcontainer LPMoverlay">
      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 18 18">
        <circle cx="9.56" cy="8.44" r="1.13" />
        <circle cx="13.5" cy="8.44" r="1.13" />
        <circle cx="5.63" cy="8.44" r="1.13" />
        <path d="M9.56,0A8.43,8.43,0,0,0,2.19,12.53L0,18l5.47-2.19A8.44,8.44,0,1,0,9.56,0Zm0,15.75A7.31,7.31,0,0,1,6,14.83l-.47-.26-.5.2L2,16l1.21-3,.2-.5L3.17,12a7.31,7.31,0,1,1,6.39,3.77Z" />
      </svg>
      <span className={isExpressCheckout() ? "chatText" : ""} style={{ marginLeft: '10px' }}>Chat</span>
    </div>
  );

  componentDidMount() {
    const pageIdProperty = validateUrl(window.location.pathname + window.location.hash?.split('?')[0]);
    setTimeout(() => {
      if (window.PageIds !== null && window.PageIds !== undefined) {
        window.inqSiteId = validateUrl(window.PageIds[pageIdProperty]);
        if (window.inqSiteId && window.Inq && window.Inq.reinitChat) {
          try {
            window.Inq.reinitChat(validateUrl(window.inqSiteId));
          } catch (err) {
            /** TODO log */
          }
        }
      }
      if (window.c2c !== null && window.c2c !== undefined) {
        try {
          window.c2c.initializeC2C([
            {
              buttonname: 'generic-c2c-container-desktop',
              targeteddiv: ['c2c_container_desktop'],
              url: '/content/vzw-engage/c2c/btn.display.generic-c2c-container-desktop.html',
            },
          ]);
        } catch (err) {
          /** TODO log */
        }
      }
    }, 2000);
  }

  isChatDevTestEnabled = () => getSession('liveSupportDevTest') === 'Y' || getSession('chatServiceDevTest') === 'Y';

  render = () => (
    <>
      {!isMobile() ? (
        <div className={isExpressCheckout() ? "skipPrint chatCall_EC" : "skipPrint"} id="chatCall">
          <div id="c2c_wrapper_desktop">
            <div id="inqC2CImgContainer_Fixed1" className="displayInlineFlex" />
            <div id="c2c-container-5g-desktop" className="c2c-container-5g-desktop" aria-label="chatIcon" role="link" tabIndex="0">
              {this.isChatDevTestEnabled() && this.chatICON}
            </div>
          </div>
        </div>
      ) : (
        <div className="c2c_container_mobile vdsUpgrade">{this.isChatDevTestEnabled() && this.chatICON} </div>
      )}
    </>
  );
}

export default ChatAndC2C;
